import React from 'react';
import colors from '../../theme/colors';

export default function AlarmBanner({ alarms }) {
  if (!alarms || alarms.length === 0) return null;

  return (
    <div style={{
      background: 'rgba(255,107,107,0.12)',
      border: `1px solid ${colors.danger}`,
      borderRadius: 8,
      padding: '10px 16px',
      marginBottom: 16,
      display: 'flex',
      alignItems: 'center',
      gap: 10,
    }}>
      <span style={{ color: colors.danger, fontWeight: 700, fontSize: 13 }}>ALARM</span>
      <span style={{ color: colors.text, fontSize: 13 }}>
        {alarms.join(' | ')}
      </span>
    </div>
  );
}
